import { Link } from 'react-router-dom';

import { LegalLayout, LegalSection } from '../../components/legal/LegalLayout';

// Versão vigente desde 26/10/2026 (antes: rascunho "v0-draft"). Fechada pro
// pedido de tokenização de cartão no Asaas, que analisa se o contrato prevê
// débito automático e alteração de valor. Cada regra aqui é o que o sistema
// FAZ hoje — mudou a regra no código, muda o texto e a versão em
// components/checkout-public/terms.ts.
export function TermsOfUsePage(): JSX.Element {
  const strong = (text: string): JSX.Element => <strong className="font-semibold text-black">{text}</strong>;
  return (
    <LegalLayout title="Termos de Uso" updatedAt="26 de outubro de 2026" preliminary={false}>
      <LegalSection title="1. Identificação">
        <p>
          Estes Termos regem a contratação de assinaturas e serviços pelo checkout da Opus Owl. O
          fornecedor é a {strong('OPUS OWL SOFTWARE E AUTOMACAO LTDA')}, CNPJ 63.789.662/0001-02, com
          sede na Rua Augusto Honório, 955, Jardim Paulistano, Franca/SP, CEP 14402-402
          (&quot;Opus Owl&quot;), responsável pelo Reservei e pelos demais sistemas Owl. Os pagamentos
          são processados pelo Asaas; a Opus Owl não é instituição financeira.
        </p>
      </LegalSection>

      <LegalSection title="2. Objeto">
        <p>
          Contratação de plano de assinatura de software (SaaS), como o Reservei, e/ou de cobranças
          avulsas, conforme o plano escolhido no checkout.
        </p>
      </LegalSection>

      <LegalSection title="3. Pagamento">
        <p>
          Aceitamos {strong('cartão de crédito e Pix')}, processados pelo {strong('Asaas')}. O valor
          cobrado é o exibido no checkout, em reais (BRL). Os dados do cartão trafegam por conexão
          criptografada e são enviados diretamente ao Asaas — não armazenamos o número nem o código de
          segurança do cartão.
        </p>
      </LegalSection>

      <LegalSection title="4. Cartão salvo e débito automático">
        <ul className="list-disc space-y-1.5 pl-5">
          <li>
            Ao pagar uma assinatura com cartão de crédito, você autoriza que o cartão fique salvo no
            Asaas de forma segura (um código que substitui o número do cartão) e que as{' '}
            {strong('mensalidades ou anuidades seguintes da mesma assinatura sejam cobradas automaticamente')}{' '}
            nesse cartão, na data de vencimento, no valor vigente do plano (cláusula 5).
          </li>
          <li>
            Se a cobrança automática for recusada, a fatura fica disponível para pagamento com outro
            cartão ou por Pix.
          </li>
          <li>
            Você pode pedir a remoção do cartão salvo a qualquer momento pelo atendimento. Ao cancelar,
            se não houver outra assinatura ativa, o cartão salvo é apagado.
          </li>
        </ul>
      </LegalSection>

      <LegalSection title="5. Preço, ciclo, teste, renovação e alterações de valor">
        <ul className="list-disc space-y-1.5 pl-5">
          <li>O plano pode ser mensal ou anual, conforme a escolha no checkout.</li>
          <li>
            Quando há período de teste, ao fim dele a assinatura passa a ser cobrada automaticamente no
            meio de pagamento cadastrado, salvo cancelamento antes do término.
          </li>
          <li>
            A assinatura {strong('renova automaticamente')} a cada ciclo até que você cancele.
          </li>
          <li>
            O valor da cobrança pode mudar nos seguintes casos:
            <ul className="mt-1.5 list-[circle] space-y-1.5 pl-5">
              <li>
                {strong('troca de plano feita por você')} — no upgrade, é cobrada na hora a diferença
                proporcional ao ciclo em curso e o novo valor vale a partir daí; no downgrade, o novo
                valor vale a partir do ciclo seguinte;
              </li>
              <li>
                {strong('fim de desconto ou cupom por prazo determinado')} — a cobrança volta ao valor
                cheio do plano;
              </li>
              <li>
                {strong('reajuste do preço do plano')} — no máximo uma vez a cada 12 meses, comunicado
                por e-mail com pelo menos 30 dias de antecedência. Se não concordar, você pode cancelar
                antes de o novo valor valer, sem multa.
              </li>
            </ul>
          </li>
        </ul>
      </LegalSection>

      <LegalSection title="6. Falta de pagamento">
        <p>
          Se uma cobrança não for paga até o vencimento, o acesso ao sistema pode ser suspenso até a
          regularização. Pagando a fatura em aberto, o acesso é liberado automaticamente.
        </p>
      </LegalSection>

      <LegalSection title="7. Cancelamento">
        <p>
          Você pode cancelar a qualquer momento pelo próprio sistema (no Reservei: menu Assinatura →
          Cancelar assinatura) ou pelo atendimento. O cancelamento interrompe as cobranças futuras, e o
          acesso continua até o fim do período já pago.
        </p>
      </LegalSection>

      <LegalSection title="8. Reembolso e direito de arrependimento">
        <p>
          Em compras pela internet, você tem direito de arrependimento em até {strong('7 dias')} da
          contratação (art. 49 do Código de Defesa do Consumidor), com reembolso integral. Fora desse
          prazo, não há reembolso proporcional do período em curso. Estornos são feitos pelo Asaas no
          meio de pagamento original; o prazo depende do emissor do cartão.
        </p>
      </LegalSection>

      <LegalSection title="9. Contestação e chargeback">
        <p>
          Em caso de estorno (chargeback) não fundamentado, o acesso poderá ser suspenso até a
          regularização, sem prejuízo das medidas cabíveis.
        </p>
      </LegalSection>

      <LegalSection title="10. Limitação de responsabilidade">
        <p>
          O serviço é fornecido no estado em que se encontra. Não nos responsabilizamos por
          indisponibilidade, falha ou atraso do Asaas ou de terceiros, nem por caso fortuito ou força
          maior, respeitados os direitos que o Código de Defesa do Consumidor torna irrenunciáveis.
        </p>
      </LegalSection>

      <LegalSection title="11. Dados pessoais">
        <p>
          O tratamento de dados pessoais segue a nossa{' '}
          <Link
            to="/politica-de-privacidade"
            className="font-medium text-brand underline underline-offset-2 hover:opacity-80"
          >
            Política de Privacidade
          </Link>
          , em conformidade com a LGPD.
        </p>
      </LegalSection>

      <LegalSection title="12. Foro e legislação">
        <p>
          Aplica-se a legislação brasileira. Fica eleito o foro da comarca de Franca/SP, ressalvado o
          direito do consumidor de propor ação no foro do seu domicílio.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
